import "../../../Styles/main.scss"
import Footer from "../../Shared/Layout/Footer"
import AuthPageDescription from "../../Shared/Primitive/AuthPageDescription"
import AuthPageImage from "../../Shared/Primitive/AuthPageImage"
import { LogoIconMobile } from "../../Shared/Components/SvgIcons"
import CreateOrganizationForm from "./CreateOrganizationForm"

function CreateOrganizationScreen() {

    return (
        <div className="auth-layout">
            <div className="auth-layout__main-container">
                <div className="left-panel">
                    <div className="left-panel__logo">
                        {" "}
                        <LogoIconMobile />
                    </div>
                    <div className="left-panel__description">
                        <AuthPageDescription />
                    </div>
                    <div className="edusiia-image">
                    <AuthPageImage />
                    </div>
                </div>
                <div className="right-panel">
                    <div className="right-panel__edusiia-image">
                        <AuthPageImage />
                    </div>
                    <div className="right-panel__edusiia-matching-form">
                        <CreateOrganizationForm />
                    </div>
                </div>
            </div>
            <Footer landingPageFooter={true} />
        </div>
    )
}

export default CreateOrganizationScreen
